// Import Framework7
import Framework7 from 'framework7/lite-bundle';

// Import Framework7-Svelte Plugin
import Framework7Svelte from 'framework7-svelte';

// Import Framework7 Styles
import 'framework7/framework7-bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.less';
import '../css/terminal-theme.css';

// Import App Component
import App from '../components/app.svelte';

// Pre-boot Authentication Guard for direct URL entry / scrapers
(function preBootAuthGuard() {
  try {
    localStorage.setItem('dealer_terminal_env', 'LIVE');
    localStorage.setItem('trading_environment', 'LIVE');
    sessionStorage.setItem('dealer_terminal_env', 'LIVE');
    sessionStorage.setItem('trading_environment', 'LIVE');
  } catch (e) {}

  const token = localStorage.getItem('token');
  const pathname = window.location.pathname || '';
  const isPublicPath = pathname === '/' || pathname === '' || pathname.startsWith('/admin-login-otp');

  if (!token && !isPublicPath) {
    window.location.replace('/');
  }
})();

// Init F7 Svelte Plugin
Framework7.use(Framework7Svelte);

// Mount Svelte App
const app = new App({
  target: document.getElementById('app'),
});